namespace Matrix.Scheduling {
    export class CalendarEntryColumns {
        static columnsKey = 'Scheduling.CalendarEntry';
    }
}
